module.exports = __webpack_public_path__ + "static/2-3b774017ce28f5e43ff0095c7b08e9b6.webp";